var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showLabel && _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.iniDisabled ? "div" : "bDropdown",
        {
          tag: "component",
          staticClass: "dropdown dropdown-listed dropdown-workspaceuser",
          class: { "is-disabled": _vm.iniDisabled },
          attrs: {
            "aria-role": "menu",
            "mobile-modal": false,
            position: _vm.position,
            disabled: _vm.iniDisabled,
          },
          on: { "active-change": _vm.addFocus },
        },
        [
          _c(
            "a",
            {
              class: [
                "button is-cancel is-outlined is-trigger",
                _vm.condensed ? "is-icon" : "pl5-xs",
              ],
              attrs: { slot: "trigger" },
              slot: "trigger",
            },
            [
              _vm.isFetching && !_vm.selectedValue
                ? _c("loader", { attrs: { text: " " } })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedValue
                ? [
                    _c("UserAvatar", {
                      staticClass: "sm m0",
                      attrs: {
                        firstName: _vm.selectedValue.profile.firstName,
                        lastName: _vm.selectedValue.profile.lastName,
                        url: _vm.selectedValue.profile.avatarUrl,
                        condensed: _vm.condensed,
                      },
                    }),
                    _vm._v(" "),
                    _vm.condensed
                      ? [
                          !_vm.iniDisabled
                            ? _c(
                                "span",
                                { staticClass: "icon" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "angle-down"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : [
                          !_vm.hideDetail
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "button is-detailMenu icon on-hover",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showDetailClick(_vm.value)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "eye"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.iniDisabled
                            ? _c(
                                "span",
                                {
                                  staticClass: "icon m0",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.clear.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "times"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                  ]
                : [
                    _c("div", { staticClass: "avatar sm m0 blank" }, [
                      _c(
                        "span",
                        { staticClass: "img" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "user"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.condensed
                        ? _c("div", { staticClass: "meta" }, [
                            _c("div", { staticClass: "name fade-50" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.showLabel && !_vm.iniDisabled
                                      ? _vm.$t("chooseUser")
                                      : ""
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    !_vm.iniDisabled
                      ? _c(
                          "span",
                          { staticClass: "icon" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "angle-down"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          !_vm.iniDisabled
            ? [
                _vm.showCurrentUser
                  ? [
                      _c(
                        "b-dropdown-item",
                        { attrs: { "aria-role": "menu-item", "has-link": "" } },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onClick(_vm.currentUser)
                                },
                              },
                            },
                            [
                              _c("UserAvatar", {
                                staticClass: "sm",
                                attrs: {
                                  firstName: _vm.currentUser.profile.firstName,
                                  lastName: _vm.currentUser.profile.lastName,
                                  url: _vm.currentUser.profile.avatarUrl,
                                  condensed: false,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", {
                        staticClass: "dropdown-divider",
                        attrs: { "aria-role": "menuitem" },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSearch
                  ? [
                      _c(
                        "b-dropdown-item",
                        { attrs: { "aria-role": "menu-item", custom: "" } },
                        [
                          _c("textInput", {
                            ref: "search",
                            attrs: { type: "SEARCH" },
                            on: { input: _vm.doSearch },
                            model: {
                              value: _vm.searchTerm,
                              callback: function ($$v) {
                                _vm.searchTerm = $$v
                              },
                              expression: "searchTerm",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "head" }, [
                        _vm.count
                          ? _c("span", { staticClass: "mr5-xs" }, [
                              _vm._v(_vm._s(_vm.count)),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("searchResults")) +
                            "\n                "
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoading
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "is-info",
                        attrs: { "aria-role": "menu-item" },
                      },
                      [_c("loader", { attrs: { text: _vm.$t("searching") } })],
                      1
                    )
                  : _vm.data && _vm.data.length == 0 && !_vm.isLoading
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "is-info",
                        attrs: { "aria-role": "menu-item" },
                      },
                      [_vm._v(_vm._s(_vm.$t("noUsersFound")))]
                    )
                  : _vm.data && _vm.data.length > 0
                  ? _vm._l(_vm.data, function (item, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          attrs: { "aria-role": "menu-item", "has-link": "" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onClick(item)
                                },
                              },
                            },
                            [
                              _c("UserAvatar", {
                                staticClass: "sm",
                                attrs: {
                                  firstName: item.profile.firstName,
                                  lastName: item.profile.lastName,
                                  url: item.profile.avatarUrl,
                                  condensed: false,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  attrs: { count: _vm.count, hidePerPage: true },
                  model: {
                    value: _vm.pagination,
                    callback: function ($$v) {
                      _vm.pagination = $$v
                    },
                    expression: "pagination",
                  },
                }),
                _vm._v(" "),
                _vm.selectedValue
                  ? [
                      _c("hr", {
                        staticClass: "dropdown-divider",
                        attrs: { "aria-role": "menuitem" },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "aria-role": "menu-item" },
                          on: { click: _vm.clear },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icon" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "times"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("clearSelection")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }